module.exports = __webpack_public_path__ + "static/img/idcard_sl.9f54071.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/idcard_sl.png
// module id = CKaa
// module chunks = 1